<template>
    <div class="box">
        <h3 class="title is-4">Cover details</h3>
        <div class="columns is-multiline">
            <div class="column is-6">
            <p><strong>Insurer</strong></p>
            <p>Initio underwritten by <a href=" https://initio.co.nz/financial-strength/" target="_blank">IAG New Zealand Limited</a></p>
            </div>
            <div class="column is-6">
                <p><strong>Vehicle</strong></p>
                <ChosenVehicle />
            </div>
            <div v-if="answers[getStep('Quote')].vehicle_cover_type !== 'third-party-only'" class="column is-6">
                <p><strong>Agreed Value</strong></p>
                <p>${{ toCurrency(answers[getStep('Quote')].vehicle_sum_insured_amount,0) }} inc GST</p>
            </div>
            <div class="column is-6">
                <p><strong>Cover</strong></p>
                <p>{{ answerLabel(getStep('Quote'), 'vehicle_cover_type') }}</p>
                <template v-if="answers[getStep('Quote')].vehicle_cover_type == 'full'">
                <p>Nil-excess Windscreen &amp; Glass cover <span class='button button--feature is-primary is-small has-text-weight-bold'>INCLUDED</span></p>
                <p v-if="answerLabel(getStep('Quote'),'vehicle_excess_under_25_note')">Cover for drivers under 25 years <span class='button button--feature is-primary is-small has-text-weight-bold'>INCLUDED</span></p>
                <p v-else>Cover for drivers under 25 years <span class='button button--feature is-danger is-small has-text-weight-bold'>EXCLUDED</span></p>
                <p v-if="answers[getStep('Quote')].vehicle_low_usage == 'yes'"
                    >Low use &lt; 5000km / year discount<span class='button button--feature is-primary is-small has-text-weight-bold'>INCLUDED</span></p>
                <p v-if="answers[getStep('Quote')].vehicle_include_roadside_assist_cover == 'yes'"
                    >Roadside Assist<span class='button button--feature is-primary is-small has-text-weight-bold'>INCLUDED</span></p>
                <p v-else>Roadside Assist<span class='button button--feature is-danger is-small has-text-weight-bold'>EXCLUDED</span></p>
                </template>
            </div>
            <div class="column is-6">
                <template v-if="answerLabel(getStep('Quote'),'vehicle_excess_under_25_note')">
                    <p><strong>Excesses</strong></p>
                    <p>{{ answerLabel(getStep('Quote'), 'vehicle_excess') }}{{ answerLabel(getStep('Quote'), 'vehicle_excess_third_party') }}<br />
                        ${{ ( ( parseInt(answers[getStep('Quote')].vehicle_excess) || parseInt(answers[getStep('Quote')].vehicle_excess_third_party)) + 500 ) }} for under 25 drivers<br /><a href="#" @click.prevent="toggleModal()">Additional excesses may apply</a>
                        <modal
                            v-if="modalOpen"
                            :class="{ 'is-active': modalOpen }"
                            v-on:childToParent="toggleModal"
                            title="List of excesses"
                            footer="Summary of policy only. Please refer to the policy wording for full details of cover."
                            >
                            <InitioExcesses />
                        </modal>
                    </p>
                </template>
                <template v-else>
                    <p><strong>Excess</strong></p>
                    <p>{{ answerLabel(getStep('Quote'), 'vehicle_excess') }}{{ answerLabel(getStep('Quote'), 'vehicle_excess_third_party') }}</p>
                </template>
            </div>
            <div class="column is-6">
                <p><strong><template v-if="isAltFlow">New </template>{{ paymentInterval(true) }} Cost</strong></p>
                <p>${{ toCurrency(answers[getStep('Quote')].vehicle_quote_premium_raw) }} inc GST</p>
            </div>
            <div v-if="!isAltFlow && !isRenewFlow" class="column is-6">
                <p><strong>Starting</strong></p>
                <p>{{ fulltextDate(answers[getStep('Confirm')].vehicle_confirm_insurance_start) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toCurrency } from '@/helpers/currencyHelper.js'
import ChosenVehicle from '@/components/initio/formulate/ChosenVehicle.vue'
import InitioExcesses from '@/components/partials/Excesses.vue'
import { fulltextDate } from '@/helpers/dateHelper.js'

export default {
    components: {
        ChosenVehicle,
        InitioExcesses
    },

    props: {

    },

    computed: {
        ...mapGetters({
            getStep: 'getStep',
            answers: 'flattenedAnswers',
            answerLabel: 'getAnswerLabel',
            paymentInterval: 'getPaymentInterval',
            isAltFlow: 'isAltFlow',
            isRenewFlow: 'isRenewFlow',
        })
    },

    methods: {
        fulltextDate,
        toCurrency,
        toggleModal: function () {
            this.modalOpen = ! this.modalOpen;
        }
    },
    data: function () {
        return {
            modalOpen: false
        }
    }
}
</script>